import { useTranslation } from 'react-i18next';
import { IoIosInformationCircle } from 'react-icons/io';

import { LegalWarning } from '@/components/legal-warning';

export function LuminaireUploadInfo() {
  const { t } = useTranslation();

  return (
    <div className="bg-day-light-3 border border-day-light-1 rounded-lg p-4 w-full">
      <div className="mb-3 flex gap-2">
        <span className="mt-0.5 flex-shrink-0">
          <IoIosInformationCircle size={18} color="#7588a3" />
        </span>
        <div className="text-sm">
          <p>
            <strong>{t('package-creation.luminaire-how-it-works-title')}</strong>{' '}
            {t('package-creation.luminaire-how-it-works-body')}
          </p>
          <p className="mt-2">{t('package-creation.luminaire-how-it-works-detail')}</p>
        </div>
      </div>

      <div className="mb-3 flex gap-2">
        <span className="mt-0.5 flex-shrink-0">
          <IoIosInformationCircle size={18} color="#7588a3" />
        </span>
        <LegalWarning className="text-sm" />
      </div>

      <div className="flex gap-2">
        <span className="mt-0.5 flex-shrink-0">
          <IoIosInformationCircle size={18} color="#7588a3" />
        </span>
        <p className="text-sm">
          <strong>{t('tender-info.tip-title')}</strong>{' '}
          {t('package-creation.luminaire-schedule-instructions')}
        </p>
      </div>
    </div>
  );
}
